export default "__VITE_ASSET__DwoUVhA5__"